import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SelectFilterModule} from '../../../../../../../components/common/select-filter/select-filter.module';
import {
    MultipleSelectFilterModule
} from '../../../../../../core/component/multiple-select-filter/multiple-select-filter.module';
import {
    MedicalRecordVisitReasonLabelsSelectFilterComponent
} from './medical-record-visit-reason-labels-select-filter.component';
import {ChipsAutocompleteModule} from "../../../../../../core/component/chips-autocomplete/chips-autocomplete.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MultipleSelectFilterModule,
        ReactiveFormsModule,
        SelectFilterModule,
        ChipsAutocompleteModule,
    ],
    declarations: [MedicalRecordVisitReasonLabelsSelectFilterComponent],
    exports: [MedicalRecordVisitReasonLabelsSelectFilterComponent]
})
export class MedicalRecordVisitReasonLabelsSelectFilterModule {
}
